import React, { useState, useEffect } from 'react';
import { CheckCircleFill } from 'react-bootstrap-icons';

const DesignOption = ({ design, handleSetDesign, selectedDesigns = [] }) => {
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [isSelected, setIsSelected] = useState(
    selectedDesigns.some((selected) => selected.handle === design.handle)
  );

  const handleLocationChange = (location, isChecked) => {
    const updatedLocations = isChecked
      ? [...selectedLocations, location]
      : selectedLocations.filter((selected) => selected !== location);

    const variant = design.variants.find((variant) => variant.title === location);

    setSelectedLocations(updatedLocations);
    handleSetDesign(design, variant, isChecked);
  };

  const isLocationDisabled = (location) => {
    // Check if the location is selected by any other design
    return selectedDesigns.some(
      (selected) => selected.location === location && selected.handle !== design.handle
    );
  };

  return (
    <div className={`design-option flex-column w-100 ${isSelected ? 'active' : ''}`}>
      <img src={design.images[0].src} className="design-image" alt={design.title} />
      <h3>{design.title}</h3>

      <label>Locations:</label>
      {design.variants.map((variant, i) => (
        <div key={i} className="checkbox-option">
          <input
            type="checkbox"
            id={`location-${design.handle}-${i}`}
            name="designLocation"
            value={variant.title}
            checked={selectedLocations.includes(variant.title)}
            disabled={isLocationDisabled(variant.title)}
            onChange={(e) => handleLocationChange(variant.title, e.target.checked)}
          />
          <label htmlFor={`location-${design.handle}-${i}`}>
            {variant.title} - {variant.price}
          </label>
        </div>
      ))}
    </div>
  );
};

export default DesignOption;
